import { render, staticRenderFns } from "./ResetPin.vue?vue&type=template&id=746c2042&scoped=true&"
import script from "./ResetPin.vue?vue&type=script&lang=js&"
export * from "./ResetPin.vue?vue&type=script&lang=js&"
import style0 from "./ResetPin.vue?vue&type=style&index=0&id=746c2042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746c2042",
  null
  
)

export default component.exports